// src/components/ConfirmModal.js
// 범용 확인 모달 — window.confirm 대체. 위험 동작(삭제 등)의 확인에 사용한다.
import React from 'react';
import '../styles/ConfirmModal.css';

const ConfirmModal = ({ title, message, confirmText = '확인', cancelText = '취소', isLoading = false, onConfirm, onClose }) => {
    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('confirm-modal-overlay') && !isLoading) {
            onClose();
        }
    };

    return (
        <div className="confirm-modal-overlay" onClick={handleOverlayClick}>
            <div className="confirm-modal">
                <div className="confirm-modal-header">
                    <h2>{title}</h2>
                </div>
                <div className="confirm-modal-body">
                    {message.split('\n').map((line, index) => (
                        <p key={index}>{line}</p>
                    ))}
                </div>
                <div className="confirm-modal-actions">
                    <button type="button" className="confirm-cancel-btn" onClick={onClose} disabled={isLoading}>
                        {cancelText}
                    </button>
                    <button type="button" className="confirm-submit-btn" onClick={onConfirm} disabled={isLoading}>
                        {isLoading ? '처리 중...' : confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
